import _ from 'lodash';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import {FeedList} from 'modules/feed';

export default connect(
  createSelector(
    (state, props) => ({
      model: _.get(state, 'collection.clippingFeed'),
      globalIds: _.get(state, 'collection.globalIds')
    })
  ,
    (state) => {
      const {globalIds, model} = state;
      return {
        model,
        query: {
          globalId: globalIds,
          limit: 50,
        },
      };
    }
  ),
  () => ({})
)(FeedList);



/** WEBPACK FOOTER **
 ** ./src/app/modules/collection/components/CollectionFeedContainer.js
 **/